// src/components/dash/components/main/components/reports/components/EnhancedHeader/styles.js
import styled from "styled-components";

export const HeaderContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.custom4};
  border-bottom: 1px solid ${({ theme }) => theme.border3};
  position: sticky;
  top: 0;
  z-index: 10;
`;

export const SearchSection = styled.div`
  display: flex;
  align-items: center;
  padding: 0.5rem;
  gap: 1rem;
  height: 3em;

  .tools {
    display: flex;
    gap: 0.5rem;
  }

  .search-input {
    display: flex;
    align-items: center;
    flex: 1;
    position: relative;

    input {
      width: 50%;
      height: 2.5em;
      padding: 0 2.5rem 0 1rem;
      background-color: ${({ theme }) => theme.card3};
      border: 1px solid ${({ theme }) => theme.border3};
      border-radius: 4px;
      color: ${({ theme }) => theme.text};
      font-size: 0.9em;
    }

    .search-btn {
      background: none;
      margin-left: 1em;
      border: none;
      display: flex;
      align-items: center;
      justify-content: center;
      opacity: 0.6;
      cursor: pointer;
      color: ${({ theme }) => theme.text};

      &:hover {
        opacity: 1;
      }

      svg {
        font-size: 1.2em;
        color: ${({ theme }) => theme.text};
      }
    }
  }

  .actions {
    display: flex;
    align-items: center;
    gap: 0.5rem;

    .total-docs {
      font-size: 0.85em;
      opacity: 0.7;
      margin-right: 0.5rem;
      white-space: nowrap;
    }
  }

  .filter-btn,
  .action-btn {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.5rem 0.75rem;
    border-radius: 4px;
    cursor: pointer;
    background-color: ${({ theme }) => theme.custom};
    border: 1px solid ${({ theme }) => theme.border3};
    color: ${({ theme }) => theme.text};
    transition: all 0.2s ease;
    opacity: 0.7;
    position: relative;

    &:hover {
      opacity: 1;
      background-color: ${({ theme }) => theme.border3};
    }

    &:hover::after {
      content: attr(data-tooltip);
      position: absolute;
      bottom: -2rem;
      left: 50%;
      transform: translateX(-50%);
      background-color: rgba(0, 0, 0, 0.8);
      color: white;
      padding: 0.25rem 0.5rem;
      border-radius: 4px;
      font-size: 0.75rem;
      white-space: nowrap;
      z-index: 1000;
    }

    &:disabled {
      opacity: 0.4;
      cursor: not-allowed;
    }

    svg {
      font-size: 1.2em;
    }

    span {
      font-size: 0.85em;
      white-space: nowrap;
    }
  }

  @media (max-width: 768px) {
    flex-wrap: wrap;
    height: auto;
    min-height: 3em;

    .tools,
    .search-input,
    .actions {
      width: 100%;
      margin-bottom: 0.5rem;
    }

    .search-input input {
      width: 80%;
    }
  }
`;

export const FilterSection = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  padding: 0.5rem;
  background-color: ${({ theme }) => theme.custom};
  border-top: 1px solid ${({ theme }) => theme.border3};
  min-height: 2.5em;
  align-items: center;
`;

export const FilterInfo = styled.div`
  display: inline-flex;
  align-items: center;
  padding: 0.25rem 0.5rem;
  background-color: ${({ theme }) => theme.card};
  border-radius: 4px;
  font-size: 0.75rem;
  gap: 0.25rem;

  .label {
    opacity: 0.7;
  }

  .value {
    font-weight: 500;
  }
`;
